import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  deleteThoughtsApiCrud,
  type DeleteThoughtsRequest,
} from "@/generated/fastapi";

export async function deleteThoughts(
  accessToken: string | null | undefined,
  request: DeleteThoughtsRequest,
) {
  const response = await deleteThoughtsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to delete thoughts (${response.status})`);
  }

  return response.data;
}
